export const API_LIST = {
  // User APIs
  LIST_USER: 'api/users/list',
  GET_ALL: 'api/users/get-all',
  USER_DETAIL: (id: number) => `api/users/${id}`,
  CREATE_USER: 'api/users/create',
  UPDATE_USER: 'api/users/update',
  DELETE_USER: (id: number) => `api/users/soft-delete/${id}`,

  // Department APIs
  LIST_DEPARTMENT: 'api/departments/list',
  DEPARTMENT_DETAIL: (id: number) => `api/departments/${id}`,
  CREATE_DEPARTMENT: 'api/departments/create',
  UPDATE_DEPARTMENT: 'api/departments/update',
  DELETE_DEPARTMENT: (id: number) => `api/departments/delete/${id}`,
  CHANGE_ACTIVE: (id: number) => `/api/users/change-active/${id}`,
  LOGIN: '/api/users/login',
  LIST_ROLE_TYPE: '/api/users/list-roles',
  PAID_LEAVE_NUMBER: `api/users/paid-leave-number`,
  LIST_TAB: `api/users/auth/tabs`,
} as const;
